/*
 * PROD
 * */
const PROD_DOMAIN = 'https://app.bifrostbooking.no/';
const PROD_API = 'https://api.bifrostbooking.no/graphql/';
const PROD_WIDGET_CSS_LINK =
  'https://horn-prod-front-end.s3.amazonaws.com/widget/static/css/main.min.css';
const PROD_WIDGET_JS_LINK =
  'https://horn-prod-front-end.s3.amazonaws.com/widget/static/js/bundle.min.js';
const PROD_WIDGET_LINK =
  'https://horn-prod-front-end.s3.amazonaws.com/hornWidget.js';

/*
 * STAGE
 * */
const STAGE_DOMAIN = 'https://stage.bifrostbooking.no/';
const STAGE_API = 'https://api-stage.bifrostbooking.no/graphql/';
const STAGE_WIDGET_CSS_LINK =
  'https://horn-fron-end.s3.amazonaws.com/widget/static/css/main.min.css';
const STAGE_WIDGET_JS_LINK =
  'https://horn-fron-end.s3.amazonaws.com/widget/static/js/bundle.min.js';
const STAGE_WIDGET_LINK =
  'https://horn-fron-end.s3.amazonaws.com/hornWidget.js';

/*
 * LOCAL
 * */
const LOCAL_DOMAIN = 'http://localhost:3000/';
// const LOCAL_API = 'http://localhost:8000/graphql/';

/*
 * GENERAL
 * */
let URI = STAGE_API;
let DOMAIN = LOCAL_DOMAIN;
let WIDGET_JS_LINK = STAGE_WIDGET_JS_LINK;
let WIDGET_CSS_LINK = STAGE_WIDGET_CSS_LINK;
let WIDGET_LINK = STAGE_WIDGET_LINK;

if (process.env.NODE_ENV === 'production') {
  if (process.env.REACT_APP_IS_STAGE_BUILD) {
    URI = STAGE_API;
    DOMAIN = STAGE_DOMAIN;
    WIDGET_JS_LINK = STAGE_WIDGET_JS_LINK;
    WIDGET_CSS_LINK = STAGE_WIDGET_CSS_LINK;
    WIDGET_LINK = STAGE_WIDGET_LINK;
  } else {
    URI = PROD_API;
    DOMAIN = PROD_DOMAIN;
    WIDGET_JS_LINK = PROD_WIDGET_JS_LINK;
    WIDGET_CSS_LINK = PROD_WIDGET_CSS_LINK;
    WIDGET_LINK = PROD_WIDGET_LINK;
  }
}

export { URI, DOMAIN, WIDGET_JS_LINK, WIDGET_CSS_LINK, WIDGET_LINK };
